import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Icon from 'components/Icon';

import {
	Container,
	Collection,
	Title,
	DateString,
	InlineButton,
	CollectionSent
} from './styles';

const List = props => {
	const { t, collections } = props;
	return (
		<Container>
			<h2>{t('collection/Collections')}</h2>
			{
				collections.map(collection => {
					const active = props.collection === collection.id;
					const date = new Date(collection.updateTime);
					const dateString = isNaN(date.getDate()) ? t('colleciton/New collection') : [
						[
							date.getDate(),
							date.getMonth() + 1,
							date.getFullYear()
						].join('.'),
						[
							date.getHours(),
							(date.getMinutes() < 10 ? '0' : '') + date.getMinutes(),
						].join(':')
					].join(' ');
					return (
						<Collection active={active} key={collection.id} onClick={() => props.collectionSelectHandler(collection.id)}>
							{
								collection.data.name !== '' &&
								<Title>
								  { collection.data.name }
								</Title>
							}
							{
								active &&
								<InlineButton active={active} onClick={e => {
								  e.preventDefault();
								  e.stopPropagation();

								  props.removeCollectionHandler(collection.id);
								}}>{t('remove')}</InlineButton> ||
								<InlineButton>{t('open')}</InlineButton>
							}
							{
								collection.data && collection.data.recipients && collection.data.recipients.length > 0 &&
								<CollectionSent><Icon icon="envelope"></Icon></CollectionSent>
							}
							<DateString>{dateString}</DateString>
							<DateString>{t('collection/Brochure', { count: collection.brochures.length })}</DateString>
						</Collection>
					)
				})
			}
		</Container>
	)
}

List.propTypes = {
	t: PropTypes.func,
	collection: PropTypes.string,
	collections: PropTypes.array,
	collectionSelectHandler: PropTypes.func,
	removeCollectionHandler: PropTypes.func,
}

export default translate('translations')(List)
